<template>
    <div
        v-if="loaded && session"
        class="game-responsive responsive_smartsoft">
        <smartsoft-frame :session="loaded ? session : null" />
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import SmartsoftFrame from '../../../common/smartsoft/smartsoft-frame.vue';

export default {
    name: 'game-smartsoft',
    components: { SmartsoftFrame },
    props: {
        gameId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loaded: false,
            isMobile: isMobile.phone || isMobile.tablet
        };
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        session() {
            return Vue.state.smartsoft.session.get();
        }
    },
    watch: {
        async $route() {
            await this.load();
        }
    },
    async created() {
        await Vue.state.player.ensure();
        await this.load();
    },
    methods: {
        async load() {
            this.loaded = false;

            if (this.isLoggedIn) {
                await Vue.state.smartsoft.session.open(this.gameId, this.lang, this.isMobile);
            } else {
                await Vue.state.smartsoft.session.openDemo(this.gameId, this.lang, this.isMobile);
            }

            if (this.isMobile) window.location.replace(this.session.gameUrl);

            this.loaded = true;
        }
    },
    beforeDestroy() {
        this.loaded = false;
    }
};
</script>
<style lang="scss" scoped>
.responsive_smartsoft {
    padding-bottom: 52.3%;
}
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-smartsoft.vue